<template>
  <div class="page">
    <div class="card card-fluid" v-if="list_todo.length > 0">
      <div class="card-header"> Active Tasks: To-Dos </div>
      <div class="card-body" >
        <div class="table-responsive" >
          <table class="table" aria-label="Notificaitons">
            <thead>
            <tr>
              <th id="request" style="min-width:256px"> Request </th>
              <th id=""></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in list_todo">
              <td class="align-middle text-truncate">
                <div class="media align-items-center">
                  <a href="#" class="tile text-white mr-2" :class="bg_color[item.initial.toLowerCase()]">{{item.initial}} </a>
                  <div class="media-body">
                    <a @click="showForm(item, $event)">{{item.module_name}}
                      <small class="d-block text-muted"><strong>{{ item.message }}</strong> <br/> Date : {{item.date}} </small>
                    </a>
                  </div>
                </div>
              </td>
              <td class="align-middle"></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header border-0" id="headingCompletedTodo">
        <button class="btn btn-block btn-reset d-flex justify-content-between collapsed" data-toggle="collapse" data-target="#completedTodo" aria-expanded="false" aria-controls="completedTodo">
          <span><em class="fa fa-history text-muted mr-2"></em> Completed ({{total}})</span>
          <span class="collapse-indicator"><em class="fa fa-fw fa-chevron-down"></em></span>
        </button>
      </div>
      <div id="completedTodo" class="collapse" aria-labelledby="headingCompletedTodo">
        <div class="card-body pt-0">
          <div class="todo-list todo-list-bordered" data-toggle="sortable" data-draggable=".todo" data-handle=".drag-handle">
            <div class="todo"  v-for="(item, i) in list_completed">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="todo2" checked disabled> <label class="custom-control-label" for="todo2">
                <span>{{item.message}}</span></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <travel-request-approval ref="travel-request" :data="data"></travel-request-approval>
    <cash-advance-approval ref="cash-advance-request" :data="data"></cash-advance-approval>
    <work-from-home-approval ref="work-from-home" :data="data"></work-from-home-approval>
    <compensatory-overtime-approval ref="compensatory-overtime" :data="data"></compensatory-overtime-approval>
    <compensatory-approval ref="compensatory" :data="data"></compensatory-approval>
    <staff-approval ref="staff" :data="data"></staff-approval>
    <leave-request-approval ref="leave-request" :data="data"></leave-request-approval>
    <overtime-approval ref="overtime" :data="data"></overtime-approval>
  </div>

</template>

<script>
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import TravelRequestApproval from "../travel-request/TravelRequestApproval";
import CashAdvanceApproval from "../cash-advance/CashAdvanceApproval";
import WorkFromHomeApproval from "../work-from-home/WorkFromHomeApproval";
import CompensatoryOvertimeApproval from "../compensatory-overtime/CompensatoryOvertimeApproval";
import CompensatoryApproval from "../compensatory/CompensatoryApproval";
import StaffApproval from "../staff/StaffApproval";
import LeaveRequestApproval from "../leave-request/LeaveRequestApproval";
import OvertimeApproval from "@/components/pages/overtime/OvertimeApproval";

export default {
  name: "NotificationsIndex",
  components: {
    OvertimeApproval,
    LeaveRequestApproval,
    StaffApproval,
    CompensatoryApproval,
    CompensatoryOvertimeApproval,
    WorkFromHomeApproval, CashAdvanceApproval, TravelRequestApproval},
  data(){
    return {
      total:0,
      perPage:10,
      currentPage:1,
      list_completed:[],
      list_todo:[],
      data:null,
      bg_color:{tr:'bg-blue',s:'bg-green',ca:'bg-purple',wfh:'bg-pink',c:'bg-red',co:'bg-orange', o:'bg-apple'},
    }
  },
  methods:{
    getListTodo(){
      this.list_todo = []
      let payload = {}
      AxiosCall.Get(payload,  urlApi.notification.list_todo).then(res=>{
        if(res.success){
          for (let data of res.atributes){
            let arrInitial = data.module_name.split(" ")
            let initial = data.module_name.substring(0, 1)
            if(arrInitial.length > 0 ){
              initial = ``
              for(let i of arrInitial){
                initial += i.substring(0, 1)
              }
            }
            data.initial = initial
            this.list_todo.push(data)
          }
        }
      })
    },
    getCompleted(){
      let payload = {}
      AxiosCall.Get(payload, urlApi.notification.completed).then(res=>{
        if(res.success){
          this.list_completed = res.atributes
          this.total = res.total
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    formatTime(minutes){
      if(minutes>60){
        let hours = minutes/60
        if(hours < 24){
          return `${Math.round(hours)} hours ago`
        }else {
          let days = hours/24
          return `${Math.round(days)} days ago`
        }

      }else{
        if(minutes < 1){
          return `a minutes ago`
        }
        return `${minutes} minutes ago`
      }
    },
    showForm(item, ev){
      ev.preventDefault()
      this.data = item
      if(this.data.module_path === "time-recording"){
        this.$router.push({name:"TimeRecordingApproval", query:{id:btoa(item.master_id)}})
      }else{
        this.$refs[item.module_path].$refs.modal.show()
      }
    },
    getData(){
      this.getCompleted()
      this.getListTodo()
      this.$root.$emit("updateNotification")
    }
  },
  created() {
    this.getCompleted()
    this.getListTodo()
    this.$root.$on("getNotification", ()=>{
      this.getData()
    })
  }
}
</script>

<style scoped>
.vertical-align{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>